<template>
  <div class="box is-centered wrapper-data-receiver">
    <h1 class="title is-4 has-text-primary title-data-receiver">
      Datos de Receptor
    </h1>

    <div class="columns is-multiline">
      <div
        v-if="!isTradeTransfer"
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <CustomerSearcherByRFC
          :disabled="isLoading || disabled"
          required
          @select="$emit('customer', $event)"
        />
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline, 'is-12': isTradeTransfer }"
      >
        <CustomerSearcherByTradeName
          :disabled="isLoading || disabled"
          required
          @select="$emit('customer', $event)"
        />
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <CustomerSearcherByEmail
          :disabled="isLoading || disabled"
          :value="$store.state.customers.email"
          required
          @select="$emit('customer', $event)"
        />
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <CustomerSearcherByName
          :disabled="isLoading || disabled"
          :value="$store.state.customers.name"
          required
          @select="$emit('customer', $event)"
        />
      </div>

      <div
        v-if="!isTradeTransfer"
        class="column is-12 is-centered"
      >
        <div class="field">
          <label
            class="label"
          >
            ¿Eres extranjero?
          </label>
          <div class="control is-flex is-centered">
            <div class="field has-addons">
              <p class="control">
                <a
                  class="button"
                  :class="{ 'is-success': isForeign, 'is-loading': isLoading }"
                  :disabled="disabled"
                  @click="onChangeForeign(true)"
                >
                  <span>Sí</span>
                </a>
              </p>
              <p class="control">
                <a
                  class="button"
                  :class="{ 'is-success': !isForeign, 'is-loading': isLoading }"
                  :disabled="disabled"
                  @click="onChangeForeign(false)"
                >
                  <span>No</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <template v-if="isForeign">
        <div
          class="column"
          :class="{ 'is-12': !inline, 'is-4': inline }"
        >
          <AppInputField
            id="address"
            name="receiverFiscalResidence"
            label="Residencia fiscal"
            placeholder="Residencia fiscal"
            :value="receiverFiscalResidence"
            :disabled="disabled"
            :is-loading="isLoading"
            @input="onChange"
            @change="onChange"
          />
        </div>

        <div
          class="column"
          :class="{ 'is-12': !inline, 'is-4': inline }"
        >
          <AppInputField
            id="numRegIdTrib"
            name="receiverNumRegIdTrib"
            label="Número de registro identificación tributaria "
            placeholder="Número de registro identificación tributaria "
            :value="receiverNumRegIdTrib"
            :disabled="disabled"
            :is-loading="isLoading"
            @input="onChange"
            @change="onChange"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'InvoiceReceiver',
  components: {
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    CustomerSearcherByRFC: () => import(/* webpackChunkName: "customer-searcher-by-rfc" */ '@/components/Admin/Customer/SearcherByRFC.vue'),
    CustomerSearcherByTradeName: () => import(/* webpackChunkName: "customer-searcher-by-trade-name" */ '@/components/Admin/Customer/SearcherByTradeName.vue'),
    CustomerSearcherByEmail: () => import(/* webpackChunkName: "customer-searcher-by-email" */ '@/components/Admin/Customer/SearcherByEmail.vue'),
    CustomerSearcherByName: () => import(/* webpackChunkName: "customer-searcher-by-name" */ '@/components/Admin/Customer/SearcherByName.vue'),
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTradeTransfer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isForeign: false,
    };
  },
  computed: {
    ...mapState({
      receiverOptionsRfcList: state => state.invoice.receiverOptionsRfcList,
      receiverRfc: state => state.invoice.receiverRfc,
      receiverName: state => state.invoice.receiverName,
      receiverCfdiUsage: state => state.invoice.receiverCfdiUsage,
      receiverFiscalResidence: state => state.invoice.receiverFiscalResidence,
      receiverNumRegIdTrib: state => state.invoice.receiverNumRegIdTrib,
    }),
  },
  watch: {
    receiverFiscalResidence(value) {
      this.isForeign = (!!value);
    },
  },
  methods: {
    ...mapMutations({
      setReceiverValue: 'invoice/setValue',
    }),
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setReceiverValue({ accessor, value });
    },
    onChangeForeign(value) {
      if (this.disabled) return;
      this.isForeign = value;
    },
  },
};
</script>

<style scoped>
.box {
  flex-direction: column;
}

.columns {
  width: 100%;
}
</style>
